import React, { useEffect, useState } from 'react';
import ContainerHeader from 'components/ContainerHeader/index';
import API from 'util/Api';
import SimpleTable from 'components/ActionsTable/SimpleTable';
import CardBox from 'components/CardBox';
import CircularProgress from '@material-ui/core/CircularProgress';
import SnackBar from 'components/SnackBar';
import CalibrationDialog from './CalibrationDialog';

const PGSCameras = (props) => {
    const [camerasTable, setCamerasTable] = useState({ headers: [], tbody: [] });
    const [appState, setAppState] = useState('loading');
    const [snackBar, setSnackBar] = useState({ open: false, message: '', type: 'error' });
    const [calibrationDialog, setCalibrationDialog] = useState({ open: false, imageUrl: '', cameraData: null, areaNames: [] });

    useEffect(() => {
        fetchPGSCameras();
    }, []);

    const fetchPGSCameras = () => {
        setAppState('loading');
        API.get('pgsCameras')
            .then((res) => {
                console.log('PGS Cameras response:', res.data);

                if (res.data.data && res.data.data.body && Array.isArray(res.data.data.body)) {
                    const cameras = res.data.data.body;
                    const headers = res.data.data.headers || [];

                    // Map camera data to match header keys
                    const tbody = cameras.map((camera, index) => ({
                        ...camera
                    }));

                    setCamerasTable({ headers, tbody });
                    setAppState('active');
                } else {
                    setCamerasTable({ headers: [], tbody: [] });
                    setAppState('active');
                }
            })
            .catch((err) => {
                console.error('Error fetching PGS Cameras:', err);
                setAppState('active');
                setSnackBar({
                    open: true,
                    message: err.response?.data?.msg || 'Error loading cameras',
                    type: 'error'
                });
            });
    };

    const handleSlotMarking = (data) => {
        API.get('cameraFrame', { params: { id: data.id, mac_address: data.mac_address } })
            .then((res) => {
                console.log('Camera frame API response:', res.data);
                const imageUrl = res.data?.data?.url;
                
                if (imageUrl) {
                    console.log('Setting calibration dialog with imageUrl:', imageUrl);
                    const areaNames = data?.slot_nos
                        ? data.slot_nos.split(',').map((name) => name.trim()).filter(Boolean)
                        : [];
                    setCalibrationDialog({
                        open: true,
                        imageUrl: imageUrl,
                        cameraData: data,
                        areaNames
                    });
                } else {
                    console.warn('No image URL found in response:', res.data);
                    setSnackBar({
                        open: true,
                        message: 'No image URL received from camera frame API',
                        type: 'error'
                    });
                }
            })
            .catch((err) => {
                console.error('Camera frame API error:', err);
                setSnackBar({
                    open: true,
                    message: err.response?.data?.msg || 'Something went wrong!',
                    type: 'error'
                });
            });
    }

    const handleCalibrationClose = () => {
        setCalibrationDialog({ open: false, imageUrl: '', cameraData: null });
    };

    const handleSnackClose = () => {
        setSnackBar(prev => ({ ...prev, open: false }));
    };

    const handleCalibrationSubmit = (polygons, areaNames) => {
        const data = {
            camera_id: calibrationDialog.cameraData?.id,
            mac_address: calibrationDialog.cameraData?.mac_address,
            polylines: polygons,
            area_names: areaNames
        };

        API.post('pklData', data)
            .then((res) => {
                setSnackBar({
                    open: true,
                    message: res.data?.msg,
                    type: 'success'
                });
                handleCalibrationClose();
            })
            .catch((err) => {
                setSnackBar({
                    open: true,
                    message: err.response?.data?.msg || 'Failed to submit calibration data',
                    type: 'error'
                });
            });
    };

    const renderContent = () => {
        switch (appState) {
            case 'loading':
                return (
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        minHeight: '400px'
                    }}>
                        <CircularProgress />
                    </div>
                );
            case 'active':
                return (
                    <>
                        {camerasTable.tbody && <SimpleTable table={camerasTable} type='pgsCameras' markSlots={handleSlotMarking} />}
                    </>
                );
            default:
                return null;
        }
    };

    return (
        <>
            <ContainerHeader title="PGS Cameras" match={props.match} />
            {renderContent()}
            <SnackBar
                open={snackBar.open}
                message={snackBar.message}
                type={snackBar.type}
                handleClose={handleSnackClose}
            />
            <CalibrationDialog
                open={calibrationDialog.open}
                imageUrl={calibrationDialog.imageUrl}
                areaNames={calibrationDialog.areaNames}
                cameraId={calibrationDialog.cameraData?.id}
                onClose={handleCalibrationClose}
                onSubmit={handleCalibrationSubmit}
            />
        </>
    );
};

export default PGSCameras;
